import type { ConfigType } from '@plone/registry';

import contentBlocks from './content';
import applyBlockEnhancers from './enhancers';
import { LOCAL_GROUPS } from './groups';
import homeBlocks from './home';
import aplicarPermissoesBlocos from './permissoes';
import slotBlocks from './slots';
import servicosBlocks from './servicos';
import subHomeBlocks from './subhome';

/**
 * Registra os blocos do portal, agrupados por onde são usados: a capa
 * (`./home`), as sub-homes (`./subhome`), a página de serviços (`./servicos`), o corpo do conteúdo (`./content`) e
 * a lateral (`./slots`).
 *
 * Os blocos que não são nossos — os do core e os dos add-ons de terceiros —
 * são estendidos em `./enhancers`.
 *
 * Por último, `./permissoes` aplica os perfis de acesso ao BlockChooser — depois
 * dos enhancers, para valer também para os blocos de terceiros.
 */
export const updateBlocksConfig = (config: ConfigType) => {
  config.blocks.groupBlocksOrder = [
    ...config.blocks.groupBlocksOrder,
    ...LOCAL_GROUPS,
  ];

  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    ...homeBlocks,
    ...contentBlocks,
    ...subHomeBlocks,
    ...servicosBlocks,
    ...slotBlocks,
  };

  applyBlockEnhancers(config);
  aplicarPermissoesBlocos(config);

  return config;
};

export default updateBlocksConfig;
